import { useState } from 'react'
import BackButton from '../../../components/common/BackButton'
import DeleteButton from '../../../components/common/DeleteButton'
import EditButton from '../../../components/common/EditButton'
import Badge from '../../../components/ui/badge/Badge'
import { useProduct } from '../../../context/ProductContext'
import ProductForm from '../ProductForm'
import ProductDelete from './ProductDelete'

const ProductResume = () => {
    const [openEdit, setOpenEdit] = useState(false)
    const [openDelete, setOpenDelete] = useState(false)
    const { detail } = useProduct()
    if (!detail) return null

    return (
        <>
            <div className='flex items-center justify-between text-gray-800 dark:text-white/90'>
                <div className='space-y-1'>
                    <div className='flex items-center gap-2'>
                        <BackButton isIconOnly />
                        <h2 className='mr-1 text-xl font-bold'>{detail.product.name}</h2>
                        {detail.product.isDefault && <Badge color='success'>Produto padrão</Badge>}
                    </div>
                    <p className='text-sm text-gray-500'>
                        {detail.business.length === 1
                            ? '1 negócio vinculado'
                            : `${detail.business.length} negócios vinculados`}
                    </p>
                </div>
                <div className='flex items-center gap-1'>
                    <EditButton handleClick={() => setOpenEdit(true)} />
                    <DeleteButton handleClick={() => setOpenDelete(true)} />
                </div>
            </div>
            <ProductForm type='edit' open={openEdit} handleClose={() => setOpenEdit(false)} />
            <ProductDelete data={detail} open={openDelete} handleClose={() => setOpenDelete(false)} />
        </>
    )
}

export default ProductResume
